import { render, staticRenderFns } from "./update-diode-form.vue?vue&type=template&id=5a8b2a6c&scoped=true&"
import script from "./update-diode-form.vue?vue&type=script&lang=js&"
export * from "./update-diode-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b2a6c",
  null
  
)

export default component.exports